module.exports = __webpack_public_path__ + "img/content1.a351ad06.png";